/* eslint-disable prettier/prettier */
import { AnimatePresence, motion } from 'framer-motion'
import { debounce } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { baseURLImage } from '../../api/api'
import { AboutProject } from '../../components/AboutProject/AboutProject'
import { Container } from '../../components/Container/Container'
import { Feedback } from '../../components/Feedback/Feedback'
import ApartmentFilter from '../../components/Flats/ApartmentFilter/ApartmentFilter'
import ApartmentTable from '../../components/Flats/ApartmentTable/ApartmentTable'
import { BackButton } from '../../components/UI/BackButton/BackButton'
import { Layout } from '../../components/UI/Layout/Layout'
import Preloader from '../../components/UI/Preloader/Preloader'
import { isMobile } from '../../helpers/isMobile'
import store from '../../store'
import { FetchLayoutsRequest } from '../../store/layouts/actions'
import { fetchProjectRequest } from '../../store/project/actions'
import { getProject } from '../../store/project/project'
import style from './FlatsPage.module.scss'

const projectNames = {
  'Академика Павлова': 'Академика Павлова',
  'Алтуфьевское 53': 'Алтуфьевском 53',
  'Амурский парк': 'Амурском парке',
  'Аэронавт': 'Аэронавте',
  'Б. Академическая 85': 'Большой Академической 85',
  'Барклая 6': 'Барклая 6',
  'Белая Дача парк': 'Белая Дача парк',
  'Большая Очаковская 2': 'Большой Очаковской 2',
  'Босфорский парк': 'Босфорском парке',
  'Бунинские луга': 'Бунинских лугах',
  'Бусиновский парк': 'Бусиновском парке',
  'Бутово парк 2': 'Бутово парке 2',
  'Витебский парк': 'Витебском парке',
  'Волга парк': 'Волга парк',
  'Волжский парк': 'Волжском парке',
  'Волоколамское 24': 'Волоколамском 24',
  'Вольта': 'Вольта',
  'Восточное Бутово': 'Восточном Бутово',
  'Второй Нагатинский': 'Втором Нагатинском',
  'Дмитровский парк': 'Дмитровском парке',
  'Жулебино парк': 'Жулебино парк',
  'Западный порт': 'Западном порте',
  'Заречный парк': 'Заречном парке',
  'Зелёный парк': 'Зелёном парке',
  'Зея парк': 'Зея парк',
  'Измайловский лес': 'Измайловском лесу',
  'Ильинские луга': 'Ильинских лугах',
  'Ильменский 17': 'Ильменском 17',
  'Исеть парк': 'Исеть парк',
  'Кавказский бульвар 51': 'Кавказском бульваре 51',
  'Кантемировская 11': 'Кантемировской 11',
  'Кольская 8': 'Кольской 8',
  'Космонавтов 11': 'Космонавтов 11',
  'Красноказарменная 15': 'Красноказарменной 15',
  'Кронштадтский 14': 'Кронштадтском 14',
  'Кронштадтский 9': 'Кронштадтском 9',
  'Кудровский парк': 'Кудровском парке',
  'Кузьминский лес': 'Кузьминском лесу',
  'Лермонтовский 54': '	Лермонтовском 54 ',
  'Лосиноостровский парк': 'Лосиноостровском парке',
  'Люберецкий': 'Люберецком',
  'Люберцы парк': 'Люберцы парк',
  'Люблинский парк': 'Люблинском парке',
  'Матвеевский парк': 'Матвеевском парке',
  'Мещерский лес': 'Мещерском лесу',
  'Митинский лес': 'Митинском лесу',
  'Михайловский парк': 'Михайловском парке',
  'Мичуринский парк': 'Мичуринском парке',
  'Московский квартал': '	Московском кварталее',
  'Мякинино парк': 'Мякинино парке',
  'Никольские луга': 'Никольских лугах',
  'Новое Очаково': '	Новом Очаково ',
  'Новохохловская 15': 'Новохохловской 15',
  'Нокса парк': 'Нокса парке',
  'Одинцово-1': 'Одинцово-1',
  'Озерный парк': 'Озерном парке',
  'Оранж парк': 'Оранж парке',
  'Открытый парк': 'Открытом парке',
  'Парковый квартал': 'Парковом квартале',
  'Первый Дубровский': 'Первом Дубровском',
  'Перовское 2': 'Перовское 2',
  'Полар': 'Поларе',
  'Полярная 25': 'Полярной 25',
  'Римского-Корсакова 11': 'Римского-Корсакова 11',
  'Руставели 14': 'Руставели 14',
  'Савин парк': 'Савин парке',
  'Саларьево парк': 'Саларьево парке',
  'Северный парк': 'Северном парке',
  'Середневский лес': 'Середневском лесу',
  'Сиберово': 'Сиберово',
  'Сигнальный 16': 'Сигнальном 16',
  'Снежный парк': 'Снежном парке',
  'Сокольнический вал 1': 'Сокольническом валу 1',
  'Таллинский парк': 'Таллинском парке',
  'Томилинский бульвар': 'Томилинском бульвар',
  'Утёс': 'Утёсе',
  'Уюн Парк': 'Уюн парке',
  'Черноморский-2': 'Черноморском-2',
  'Юнино': 'Юнино',
  'Ютаново': 'Ютаново',
  'Янинский лес': 'Янинском лесу',
  'Ярославский': 'Ярославском',
  'Ярославский квартал': 'Ярославском квартале',
  'Яуза парк': 'Яуза парке',
  'Green Park': 'Green Park',
  'Holland park': 'Holland park',
  'Vangarden': 'Vangarden',
  'Шкиперский 19': 'Шкиперском 19',
}

export const FlatsPage = () => {
  const { pending, project } = useSelector(getProject)
  const { id } = useParams()
  const [isWhite, setIsWhite] = useState<boolean>(window.innerWidth < 768)

  const checkIsWhite = debounce(() => {
    setIsWhite(window.innerWidth < 768)
  }, 500)

  useEffect(() => {
    if (id) {
      store.dispatch(fetchProjectRequest({ id }))
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', checkIsWhite)
    window.scrollTo(0, 0)

    return () => {
      window.removeEventListener('resize', checkIsWhite)
    }
  }, [])

  return (
    <>
      <AnimatePresence>
        {pending || !project ? (
          <Preloader key='preloader' classModifiers={['screen']} />
        ) : (
          <Layout isWhite={isWhite}>
            <div className={style.FlatsPage}>
              <Container>
                <motion.div
                  animate={{ opacity: 1 }}
                  initial={{ opacity: 0 }}
                  transition={{ ease: 'linear', duration: 0.5, delay: 2 }}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 2,
                  }}
                >
                  <div>
                    <BackButton
                      url={`/project/${id}`}
                      classModifiers={['project-inner']}
                      isWhite={isMobile()}
                    />
                  </div>
                </motion.div>
                <AboutProject
                  title={(projectNames as any)[`${project.short_name}`]
                    ? `Квартиры в ${(projectNames as any)[`${project.short_name}`]}`
                    : `Квартиры в ${project.short_name}`
                  }
                  image={`${baseURLImage}${project.slides[0].SRC}`}
                  classModifiers={['project-inner']}
                  breadcrumbs={[
                    {
                      name: project.short_name,
                      url: '/',
                    },
                    {
                      name: 'Квартиры',
                      url: '',
                    },
                  ]}
                />
              </Container>
              <Container>
                {id && (
                  <div className={style.FlatsPage__container}>
                    <ApartmentFilter id={id} />
                  </div>
                )}
              </Container>
              <ApartmentTable projectName={project.short_name} />
            </div>
            <Feedback />
          </Layout>
        )}
      </AnimatePresence>
    </>
  )
}
